







import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';

@Component({
  components: { AdminIframe, PageTitle },
})
export default class AdminEditIframe extends Vue {
  private title = '운영자 수정';
  private remoteSrc = '';

  private setRemoteSrc() {
    const query = this.$route.query;

    const adminNo = this.$route.params.adminNo;
    
    const queryString = new URLSearchParams({ ...query, serviceType: 'PREMIUM' }).toString();
    this.remoteSrc =
      process.env.VUE_APP_ADMIN_REMOTE_URL + `/configuration/management/edit/${adminNo}?${queryString}`;
  }

  created() {
    this.setRemoteSrc();
  }
}
